export default "__VITE_ASSET__ceada6bb__"